import { useEffect, useMemo } from 'react';

interface StructuredDataProps {
  data: Record<string, unknown>;
  id?: string;
}

function slugifyId(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9_-]+/g, '-');
}

export default function StructuredData({ data, id }: StructuredDataProps) {
  const scriptId = useMemo(() => {
    if (id) return `structured-data-${slugifyId(id)}`;
    const type = typeof data['@type'] === 'string' ? String(data['@type']) : 'schema';
    return `structured-data-${slugifyId(type)}`;
  }, [data, id]);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.id = scriptId;

    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.remove();
    }

    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(scriptId);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [data, scriptId]);

  return null;
}
